<template>
  <!--
     The complexity of this old architecture code is not evolutive in terms of CSS styling.
     The whole template architecture should be remade with a better logic and condition handling.
     -- Ryo
  -->
  <v-app>
    <div v-if="(login && !home) || page404"></div>
    <div class="app-container" v-else>
      <div class="app-header-wrapper">
        <v-toolbar id="app-toolbar" class="app-toolbar">
          <div v-if="intro">
            <v-tour
              name="myTour"
              :steps="vueTour.steps"
              :callbacks="vueTour.callbacks"
              :options="vueTour.options"
            ></v-tour>
          </div>
          <span v-if="home">
            <img
              class="headline-logo"
              v-if="home"
              :src="logo"
              alt="Logo Solutions +"
              style="max-width: none;width: 85px;margin: 19px 17px 0 12px;"
              data-v-step="6"
            />
          </span>
          <span v-else>
            <img
              class="headline-logo"
              :src="logo"
              alt="Logo Solutions +"
              style="max-width: none;width: 85px;margin: 19px 17px 0 12px;"
              data-v-step="6"
              @click="route('VisionGlobale')"
            />
          </span>
          <span
            v-if="!home"
            class="headline-link"
            @click="route('VisionGlobale')"
          >
            <v-toolbar-title class="headline">
              <span class="font-weight-light">OptiFlux</span><br />
              <span class="baseline">
                CONSULTATION, SAISIE ET OPTIMISATIONS</span
              >
            </v-toolbar-title>
          </span>
          <v-spacer></v-spacer>
          <div class="toolbar-nav">
            <the-nav-bar
              :has0Import="home || login"
              v-on:load-spinner="showSpinner"
              v-on:hide-spinner="hideSpinner"
            />
          </div>
          <div class="spinner-wrapper">
            <spinner  v-if="isSpinnerShown === true" :message="spinnerMessage" :displayInfos="true"/>
          </div>
          <div class="spinner-wrapper">
            <spinner  v-if="spinnerTemplate" :message="messageSpinnerTemplate" :displayInfos="false"/>
          </div>
        </v-toolbar>
      </div>
      <div class="nav-account-bar">
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <span v-on="on" class="user-info"
              >Bienvenue, {{ userInfo.firstName }}
              {{ userInfo.lastName.toUpperCase() }}</span
            >
          </template>
          <div class="user-info-tooltip">
            <span class="name">
              {{ userInfo.firstName }} {{ userInfo.lastName.toUpperCase() }}
            </span>
            <v-divider />
            <span class="coop">
              <v-icon>group</v-icon>
              {{ userInfo.coop }}
            </span>
            <v-divider />
            <span class="email">
              <v-icon>email</v-icon>
              {{ userInfo.email }}
            </span>
          </div>
        </v-tooltip>
      </div>
    </div>
    <v-content>
      <router-view />
    </v-content>
    <div v-if="home || login || page404"></div>
    <div v-else class="bottom-menu">
      <div class="bottom-menu-inner">
        <v-btn
          @click="startIntro"
          class="bottom-menu-item relaunch-tuto"
          tooltip="Relancer le tutoriel"
          large
          icon
        >
          <v-icon>help</v-icon>
        </v-btn>
        <div class="bottom-menu-item message-support">
          <v-dialog v-model="dialog" width="500">
            <template v-slot:activator="{ on }">
              <v-btn
                class="icon-message"
                large
                tooltip="Support"
                icon
                v-on="on"
              >
                <v-icon>chat</v-icon>
              </v-btn>
            </template>
            <v-card>
              <v-card-title class="headline head-message" primary-title>
                Suggestion / Remarque
              </v-card-title>
              <v-card-text>
                <v-form>
                  <v-divider></v-divider>
                  <v-textarea
                    v-model="email"
                    label=""
                    full-width
                    single-line
                  ></v-textarea>
                </v-form>
                <v-btn @click="sendEmail" class="opti-btn">
                  Envoyer
                </v-btn>
              </v-card-text>

              <v-divider></v-divider>

              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="opti-orange" flat @click="dialog = false">
                  Fermer
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </div>
      </div>
    </div>
    <div v-if="!login" class="bottom-mentions">&copy; Solutions +<br /></div>
  </v-app>
</template>

<script>
import router from '@/router';
import Spinner from '@/components/AppSpinner';
import axios from 'axios';
import TheNavBar from '@/components/TheNavBar';

export default {
  data() {
    return {
      logo: require('@/assets/images/LCA_SERVICES_SOLUTIONS.png'),
      vueTour: {
        options: {
          labels: {
            buttonSkip: 'Passer le tutoriel',
            buttonPrevious: 'Retour',
            buttonNext: 'Suivant',
            buttonStop: 'Finir le tutoriel',
          },
        },
        steps: [
          {
            target: '.v-step-0',
            content: "Téléchargez le template d'import de scénario",
          },
          {
            target: '.v-step-1',
            content: "Importez le template d'import complété",
          },
          {
            target: '.v-step-2',
            content: 'Visualisez le contenu du scénario avant optimisation',
          },
          {
            target: '.v-step-3',
            content: "Lancez l'optimisation",
          },
          {
            target: '.v-step-4',
            content: "Visualisez le résultat de l'optimisation",
          },
          {
            target: '.v-step-5',
            content: 'Exportez le résultat',
          },
          {
            target: "[data-v-step='6']",
            content:
              'Revenez à ce tableau de bord "Vision Globale" quand vous le souhaitez. Bonne visite !',
            params: {
              placement: 'top',
            },
          },
        ],
        callbacks: {
          onStop: this.stopIntro,
        },
      },
      dialog: false,
      email: '',
      emailText: '',
      user: '',
      buttonsPaletteOpen: false,
      spinnerTemplate: false,
      messageSpinnerTemplate: ''
    };
  },
  components: {
    TheNavBar,
    Spinner,
    // BottomNav
  },
  computed: {
    spinnerMessage: {
      get() {
        const userInfos = this.$store.state.userInfos;
        if (userInfos.optimizing === true) {
          return 'Optimisation en cours...';
        } else if (userInfos.exporting === true) {
          return 'Export en cours...';
        }else if (userInfos.importing === true) {
          return 'Import en cours...';
        } 
        return null;
      },
    },
    isSpinnerShown: {
      get() {
        return (   
          this.$store.state.userInfos.exporting === true ||
          this.$store.state.userInfos.importing === true ||
          this.$store.state.userInfos.optimizing === true 
        );
      },
    },
    home() {
      if (this.$route.path === '/accueil') {
        return true;
      } else {
        return false;
      }
    },
    login() {
      if (this.$route.path === '/') {
        return true;
      } else {
        return false;
      }
    },
    intro() {
      if (this.$store.state.intro === true) {
        return true;
      } else {
        return false;
      }
    },
    page404() {
      if (this.$route.name === '404') {
        return true;
      } else {
        return false;
      }
    },
    userInfo: {
      get() {
        return {
          firstName: this.$store.state.userFirstName,
          lastName: this.$store.state.userLastName,
          email: this.$store.state.user,
          coop: this.$store.state.userCoop,
        };
      },
    },
  },
  methods: {
    route(pathName) {
      this.$store.dispatch('stopIntervalTimer');
      this.$router.push({ name: pathName });
    },
    showSpinner: function(message) {
      this.messageSpinnerTemplate = message;
      this.spinnerTemplate = true;
    },
    hideSpinner() {
      this.spinnerTemplate = false;
    },
   /*  showSpinner() {
      this.isSpinnerShown = true;
    },
    hideSpinner() {
      this.isSpinnerShown = false;
    }, */
    toggleButtonsPalette() {
      this.buttonsPaletteOpen = !this.buttonsPaletteOpen;
    },
    removeUser() {
      this.$store.dispatch('removeUser');
    },
    stopIntro() {
      this.$store.dispatch('desactivateIntro');
    },
    startIntro() {
      this.$store.dispatch('activateIntro');
      router.go();
    },
    sendEmail() {
      this.emailText = this.email;
      this.email = '';
      if (this.emailText.length > 0) {
        const url =
          process.env.VUE_APP_BASE_URL + process.env.VUE_APP_SEND_MAIL;
        let message = this.emailText;
        axios({
          method: 'post',
          url: url,
          data: {
            content: message,
            from: this.$store.state.user,
          },
          headers: {
            'Content-Type': 'application/json',
            user: this.$store.state.user,
          },
        }).then(() => {
          this.$toasted.show('Votre message est envoyé, merci !', {
            type: 'success',
          });
        });
      }
      this.dialog = false;
    },
  },
};
</script>

<!--style lang="scss"-->
<style lang="scss">
@import 'assets/scss/main';

.dropdown-menu--menu,
.dropdown-menu--navbar,
.dropdown-menu--sidemenu {
  visibility: hidden;
}

#app-toolbar {
  .headline-logo {
    // filter: brightness(0) invert(1);
  }
}
</style>
